import { useSearchParams } from 'react-router-dom';
import { useGraphQl } from './useGraphQl';
import { useState, useEffect } from 'react';

export const useUrlParamGraphQl = (query, update, modifyUrlParams) => {
  const {
    loading,
    fetchError,
    fetchData,
    setQueryVariables: setBaseQueryVariables,
    setUpdateVariables,
    updating,
    updateError,
    updateResponse,
  } = useGraphQl(query, update);

  const [miscVariables, setMiscVariables] = useState<any>(null);

  const [searchParams] = useSearchParams();
  const [urlParams, setUrlParams] = useState<any>(null);

  useEffect(() => {
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    setUrlParams(modifyUrlParams(params));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, setUrlParams]);

  useEffect(() => {
    if (urlParams && miscVariables) {
      const queryVariables = { ...urlParams, ...miscVariables };
      setBaseQueryVariables(queryVariables);
    }
  }, [urlParams, miscVariables, setBaseQueryVariables]);

  return {
    loading,
    fetchError,
    fetchData,
    updating,
    updateError,
    updateResponse,
    setQueryVariables: setMiscVariables,
    setUpdateVariables,
  };
};
